/** @jsxImportSource theme-ui */
import React from 'react';
import { StyleOverrideProps } from '../utils/types';
import { ResponsiveStyleValue } from 'theme-ui';

export interface ImageProps extends StyleOverrideProps {
    src: string;
    srcSet?: string;
    altText: string;
    height?: ResponsiveStyleValue<number | string>;
    width?: ResponsiveStyleValue<number | string>;
}

export function Image({ src, srcSet, altText, height, width, sx, ...otherProps }: ImageProps): JSX.Element {
    return (
        <img
            src={src}
            srcSet={srcSet}
            alt={altText}
            sx={{ height, width, boxSizing: 'content-box', ...sx }}
            {...otherProps}
        />
    );
}

Image.defaultProps = {
    height: 'auto',
    width: 'auto',
};
